// extracted by mini-css-extract-plugin
export default {"userAddressHeader":"ServiceCenterHeader_userAddressHeader__YKlPC","serviceTitle":"ServiceCenterHeader_serviceTitle__nPjvb","backButton":"ServiceCenterHeader_backButton__yEbTx"};